import { useEffect } from "react";

export const defaultUnloadMessage = "Are you sure you want to leave this page? Any data you have entered so far will be lost";

interface BeforeUnloadEvent {
    preventDefault: () => void;
    returnValue: string;
}

/**
 * Gives the user a warning in the form of a browser rendered popup if they try to navigate away from the
 * page.
 */
export default function useBeforeUnload(isEnabled: boolean) {
    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (isEnabled) {
                e.preventDefault();
                e.returnValue = defaultUnloadMessage;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isEnabled])
};
